import router from '../router/index';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, getRoles, getName } from './localStorage'; // getToken from cookie

NProgress.configure({
  showSpinner: false,
}); // NProgress Configuration

const whiteList = ['/login', '/aiToolbar', '/vipGiftRecommend', '/promotionSubmit', '/qwReplyRecommend']; // no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  // console.log('权限校验')
  if (getToken()) {
    // 判断是否有token
    if (to.path === '/login') {
      next({
        path: '/index',
      });
      NProgress.done(); // finish progress bar
    } else {
      next(); //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next('/login'); // 否则全部重定向到登录页
      NProgress.done(); // finish progress bar
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
